export const todayDiagnosisMenuList = ['전체', '상담 대기', '상담 완료'];
